import { useMemo, FC } from 'react';

import { AppQrCode } from 'components/AppQrCode';
import { AppleAppStoreLink } from 'components/AppleAppStoreLink';
import { GooglePlayStoreLink } from 'components/GooglePlayStoreLink';
import { getHeapUserId } from 'util/Analytics';
import { Icon } from 'components/Icon';
import Typography from '../Typography/Typography';
import { isAndroid } from 'util/Platform';
import { stringifyUrl } from 'query-string';
import { useTranslation } from 'react-i18next';

import styles from './ExploreApp.module.scss';

export const ExploreApp: FC = () => {
  const { t } = useTranslation();
  const heapUserId = getHeapUserId();

  const url = useMemo(() => stringifyUrl({
    url: `${window.location.origin}/online-order/app`,
    query: { heapUserId },
  }), [heapUserId]);

  return (
    <section className={styles.exploreAppWrapper} data-testid={'explore-app'}>
      <article>
        <div className={styles.title}>
          <Typography.Heading1>{t('exploreApp.title')}</Typography.Heading1>
        </div>
        <div className={styles.subtitle}>
          <Typography.Heading2>{t('exploreApp.subtitle')}</Typography.Heading2>
        </div>
        <figure className={styles.qrCode}>
          <Typography.Body><figcaption>{t('exploreApp.qr.caption')}</figcaption></Typography.Body>
          <AppQrCode width={120} height={120} />
        </figure>
      </article>
      <Icon name={'login'} height={300} width={300} className={styles.loginIcon} />
      <div className={styles.badges}>
        {isAndroid() ? <GooglePlayStoreLink url={url} /> : <AppleAppStoreLink />}
      </div>
    </section>
  );
};
